import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Banner,
  EmptyState,
  Layout,
  LegacyCard,
  Select,
  Pagination,
  Divider,
  Spinner,
} from "@shopify/polaris";
import GdprTable from "./Table";
import { getgdprData } from "../../redux/gdpr/Action";
import { useSelector, useDispatch } from "react-redux";
import AppPageFrame from "../../components/layout/AppPageFrame";

const Gdpr = () => {
  const [type, setType] = useState("SHOP_REDACT");
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();

  const totalGDPRList = useSelector((store) => store.requiredGdprReducer) || {};
  const gdprData = totalGDPRList.gdprData || {};
  const gdprContant = useMemo(
    () => (Array.isArray(gdprData.content) ? gdprData.content : []),
    [gdprData.content]
  );
  const pageCount = Number.isSafeInteger(gdprData.totalPages)
    ? Math.max(gdprData.totalPages, 0)
    : 0;
  const isLoading = Boolean(
    totalGDPRList.isRequest ||
      (!totalGDPRList.isSuccess && !totalGDPRList.isError)
  );
  const error =
    typeof totalGDPRList.error === "string" && totalGDPRList.error.trim()
      ? totalGDPRList.error
      : totalGDPRList.isError
      ? "GDPR requests could not be loaded."
      : null;

  const loadPage = useCallback(
    (page) => dispatch(getgdprData({ type, page })),
    [dispatch, type]
  );

  useEffect(() => {
    setCurrentPage(0);
    loadPage(0);
  }, [loadPage]);

  const handleNumberofEntries = useCallback(
    (newValue) => setType(newValue),
    []
  );

  const displayLenghtOptions = [
    { label: "Shop redact", value: "SHOP_REDACT" },
    { label: "Customer redact", value: "CUSTOMER_REDACT" },
    { label: "Customer request", value: "CUSTOMER_REQUEST" },
  ];

  const handlePreviousPagination = () => {
    if (currentPage <= 0 || isLoading) return;
    const previousPage = currentPage - 1;
    setCurrentPage(previousPage);
    loadPage(previousPage);
  };

  const handleNextPagination = () => {
    if (currentPage >= pageCount - 1 || isLoading) return;
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    loadPage(nextPage);
  };

  const content = isLoading ? (
    <div style={{ display: "flex", justifyContent: "center", padding: "32px" }}>
      <Spinner accessibilityLabel="Loading GDPR requests" size="large" />
    </div>
  ) : error ? (
    <Banner
      title="GDPR requests are unavailable"
      status="critical"
      action={{ content: "Retry", onAction: () => loadPage(currentPage) }}
    >
      <p>{error}</p>
    </Banner>
  ) : gdprContant.length === 0 ? (
    <EmptyState heading="No GDPR requests found">
      <p>There are no requests for the selected type.</p>
    </EmptyState>
  ) : (
    <GdprTable gdprContant={gdprContant} />
  );

  return (
    <AppPageFrame title="GDPR">
      <Layout>
        <Layout.Section>
          <div className="wrapper">
            <LegacyCard sectioned>
              <div className="d-flex justify-content-between flex-wrap">
                <div>
                  <Select
                    label="Type"
                    options={displayLenghtOptions}
                    onChange={handleNumberofEntries}
                    value={type}
                  />
                </div>
              </div>
              <div className="mt-10">
                {content}
              </div>
              {pageCount > 1 && !error ? (
                <>
                  <Divider />
                  <div
                    className="mt-10 justify-content-center"
                    style={{ display: "flex" }}
                  >
                    <Pagination
                      label={`Page ${currentPage + 1} of ${pageCount}`}
                      hasPrevious={currentPage > 0}
                      onPrevious={handlePreviousPagination}
                      hasNext={currentPage < pageCount - 1}
                      onNext={handleNextPagination}
                    />
                  </div>
                </>
              ) : null}
            </LegacyCard>
          </div>
        </Layout.Section>
      </Layout>
    </AppPageFrame>
  );
};

export default Gdpr;
